import ColorPicker from './ColorPicker'
import DatePicker from './DatePicker'
import Spinner from './Spinner'
import GridSpinner from './GridSpinner'
import TimeSpinner from './TimeSpinner'
import Input from './InputConfig'
import Checkbox from './Checkbox'
import Radiobox from './Radiobox'
import Select from './SelectConfig'
import Border from './Border'
import FontStyle from './FontStyle'
import TextAlign from './TextAlign'
import Slider from './Slider'
import ColorThemeConfig from './ColorThemeConfig'
import MarklineConfig from './MarklineConfig'
import ScrollMode from './ScrollMode'
import ImageUploader from './ImageUploader'
import IconUploader from './IconUploader'
import CellsConfig from './CellsConfig'
import MergeDataConfig from './MergeDataConfig'
import Icon from './Icon'
export default {
  ColorPicker,
  DatePicker,
  Spinner,
  GridSpinner,
  TimeSpinner,
  Input,
  Checkbox,
  Radiobox,
  Select,
  Border,
  FontStyle,
  TextAlign,
  Slider,
  ColorThemeConfig,
  MarklineConfig,
  CellsConfig,
  ScrollMode,
  ImageUploader,
  IconUploader,
  MergeDataConfig,
  Icon
}
